import { useTranslation } from "react-i18next"
import { RadioGroup } from "@/components/ui/radio-group"
import { RadioGroupItemCustom } from "@/modules/patients/agenda/teleconsultation/booking/components/radio-group-item"
import { AppointmentType } from "@/types/__generated__/union-types"

type AppointmentTypeItem = {
  label: string
  value: AppointmentType
  disabled: boolean
}

export const ConsultationTypeGroup = ({
  onChange,
  value,
  selectableAppointmentTypes,
  isFollowUpDisabled,
}: {
  value?: AppointmentType
  onChange: (e: AppointmentType) => void
  selectableAppointmentTypes: AppointmentType[]
  isFollowUpDisabled: boolean
}) => {
  const { t } = useTranslation()

  const appointmentTypes: AppointmentTypeItem[] = selectableAppointmentTypes.map((appointmentType) => ({
    label: t(`scheduling.waitingRoom.appointmentType.${appointmentType}`),
    value: appointmentType,
    disabled: appointmentType === "FOLLOW_UP" && isFollowUpDisabled,
  }))

  return (
    <div className="flex flex-col gap-2" data-testid="consultation-type">
      <label className="text-on-surface-subdued text-sm" data-testid="consultation-type-label">
        {t("scheduling.waitingRoom.priority.consultationType")}
      </label>
      <RadioGroup
        defaultValue="NORMAL"
        value={value}
        className="flex flex-wrap gap-2"
        data-testid="consultation-type-group"
        onValueChange={onChange}>
        {appointmentTypes.map((appointmentType) => {
          const { value, label, disabled } = appointmentType
          return (
            <RadioGroupItemCustom
              key={value}
              value={value}
              groupName="consultation-type"
              label={label}
              disabled={disabled}
            />
          )
        })}
      </RadioGroup>
    </div>
  )
}
